import {
  IconDefinition,
  faCubes,
  faBullseye,
  faInfoCircle,
  faBan,
  faPlus,
  faCodeBranch,
  faSignOutAlt,
  faTools,
  faTachometerAlt,
  faChartLine,
  faList,
  faShip,
  faCarAlt,
  faMale,
  faChild,
  faBaby,
  faExclamation,
  faChessQueen,
  faMapMarkerAlt,
  faMapSigns,
  faPoundSign,
  faUtensils,
  faBarcode,
  faExternalLinkAlt,
  faUndoAlt,
  faDollyFlatbed,
  faBoxes,
  faSitemap,
  faPlane,
  faCube,
  faBoxOpen,
  faEraser,
  faTerminal,
  faLaptopCode,
  faPlayCircle,
  faPlay,
  faShieldAlt,
  faAngleDoubleRight,
  faUserShield,
  faUserFriends,
  faKey,
  faFilter,
  faSortAmountUp,
  faToolbox,
  faCloudSunRain,
  faCar,
  faEllipsisH,
  faStar,
  faCode,
  faBriefcase,
  faLandmark,
  faTimes,
  faCloudUploadAlt,
  faComment,
  faFile,
  faIdCard,
  faIdBadge,
  faUserTie,
  faFolder,
  faUsers,
  faSave,
  faFilePdf,
  faClipboardCheck,
  faUndo,
  faDownload,
  faSync,
  faCheck,
} from '@fortawesome/free-solid-svg-icons'

export const solidIcons: IconDefinition[] = [
  faAngleDoubleRight,
  faCubes,
  faBullseye,
  faInfoCircle,
  faBullseye,
  faBan,
  faPlus,
  faCodeBranch,
  faSignOutAlt,
  faTools,
  faTachometerAlt,
  faChartLine,
  faList,
  faShip,
  faCarAlt,
  faMale,
  faChild,
  faBaby,
  faExclamation,
  faChessQueen,
  faMapMarkerAlt,
  faMapSigns,
  faPoundSign,
  faUtensils,
  faBarcode,
  faExternalLinkAlt,
  faUndoAlt,
  faDollyFlatbed,
  faBoxes,
  faSitemap,
  faPlane,
  faCube,
  faBoxOpen,
  faEraser,
  faTerminal,
  faLaptopCode,
  faPlayCircle,
  faPlay,
  faShieldAlt,
  faExternalLinkAlt,
  faUserShield,
  faUserFriends,
  faKey,
  faFilter,
  faSortAmountUp,
  faToolbox,
  faCloudSunRain,
  faCar,
  faEllipsisH,
  faStar,
  faCode,
  faTimes,
  faBriefcase,
  faLandmark,
  faCloudUploadAlt,
  faComment,
  faFile,
  faIdCard,
  faIdBadge,
  faUserTie,
  faFolder,
  faInfoCircle,
  faUsers,
  faSave,
  faFilePdf,
  faClipboardCheck,
  faUndo,
  faDownload,
  faSync,
  faCheck,
]
